// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountUpsearchModelResponse {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountUpsearchModelResponse.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountUpsearchModelResponse.discriminator = undefined;
EnterpriseCoordinatorAccountUpsearchModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnterpriseCoordinatorAccountUpsearchResponseModel"
    }
];
//# sourceMappingURL=enterpriseCoordinatorAccountUpsearchModelResponse.js.map